import set from 'lodash.set'
import React from 'react'

import { updateEventFeed } from '../../../services/data-explorer'
import { useRequestConfig } from '_hooks'
import { useEventFeedsContext } from '../../pages/event-feeds/context/index.jsx'
import PeriodSelect, { monthStrToDate } from '_components/period-select/index.jsx'
import { TIME_PERIOD_VALUES } from '_components/period-select/index.jsx'
import formatAmericanDashDate from '../../lib/dateUtils'

const PeriodSelectStored = ({
  className,
  style,
  visualizationsPath,
  minDate = '2000-01-01',
  customOptions,
  label,
  defaultOverrides = {},
  vertical,
}) => {
  const { id, data, dispatch, ACTIONS } = useEventFeedsContext()
  const { start, end, period } = useRequestConfig(visualizationsPath, defaultOverrides)

  const persistPeriod = (periodValue) => {
    const newValue = { ...data?.visualizations }

    set(newValue, visualizationsPath + '.period', periodValue)
    if (period === TIME_PERIOD_VALUES.CUSTOM) {
      set(newValue, visualizationsPath + '.start', start)
      set(newValue, visualizationsPath + '.end', end)
    }

    const newData = { ...data, visualizations: newValue }
    updateEventFeed(id, newData)
    dispatch({ type: ACTIONS.SET_DATA, payload: newData })
  }

  const persistStart = (strMonthYear) => {
    const newValue = {
      ...set(
        data?.visualizations,
        visualizationsPath + '.start',
        formatAmericanDashDate(monthStrToDate(strMonthYear))
      ),
    }
    const newData = { ...data, visualizations: newValue }
    updateEventFeed(id, newData)
    dispatch({ type: ACTIONS.SET_DATA, payload: newData })
  }

  const persistEnd = (strMonthYear) => {
    const newValue = {
      ...set(
        data?.visualizations,
        visualizationsPath + '.end',
        formatAmericanDashDate(monthStrToDate(strMonthYear))
      ),
    }
    const newData = { ...data, visualizations: newValue }
    updateEventFeed(id, newData)
    dispatch({ type: ACTIONS.SET_DATA, payload: newData })
  }

  return (
    <If condition={data?._id || id === 'discovery'}>
      <PeriodSelect
        className={className}
        style={style}
        minDate={minDate}
        monthFrom={start}
        monthTo={end}
        period={period}
        label={label}
        onMonthFromChange={(monthFrom) => persistStart(monthFrom)}
        onMonthToChange={(monthTo) => persistEnd(monthTo)}
        onPeriodChange={(periodValue) => persistPeriod(periodValue)}
        customOptions={customOptions}
        vertical={vertical}
      />
    </If>
  )
}

export default PeriodSelectStored
